import React from 'react';
import {Button, Flex, Form, message} from "antd";
import {getProductSubCategoryList, registerReport, StyledPopUp} from "../../../../shared";
import {ReportPopupProps} from "../../models";
import {useForm} from "antd/es/form/Form";
import {useParams} from "react-router-dom";
import TextArea from "antd/es/input/TextArea";
import {connect} from "react-redux";
import {withRouter} from "../../../../utils/services/with-router";

const ReportPopup = ({open,onCansel,registerReport} : ReportPopupProps) => {
    const [form] = useForm();
    const { id } = useParams();
   const onFinish = (value:any) => {
       let model = {
           id: id,
           body: value.body,
       }
       registerReport(model)
           .then((data: any) => {
               if (data.payload != undefined) {
                   message.success('گزارش با موفقیت ثبت شد !')
                   onCansel();

               }
           })
           .catch((e: any) => {
           });
   }
    return (
        <StyledPopUp
            open={open}
            onCancel={onCansel}
            title={'ثبت گزارش تخلف'}
            width={"100%"}
            footer={null}
            transitionName={''}
        >
            <Form form={form} onFinish={onFinish}>
               <Flex vertical gap={"middle"}>
                   <Form.Item name={"body"} label={'توضیحات'}>
                       <TextArea rows={5}/>
                   </Form.Item>
                   <Button type={"primary"} htmlType={"submit"} block size={"large"}>ثبت گزارش</Button>

               </Flex>

            </Form>
        </StyledPopUp>
    );
};
export default connect(null, {registerReport})(withRouter(ReportPopup));
